import Vue from "vue";
import { mapGetters, mapMutations, mapState } from "vuex";

import comboComponent from "@/components/child/form/combo.vue";
import gridComponent from "@/components/child/grid/grid.vue";
import { GridColumn, GridColumnType } from "@/components/child/grid/gridColumn";
import ConfiguracoesImpresaoXLSComponent from "@/components/parent/relatorio/configuracoesImpresaoXLS";
import configuracoesImpresaoXLSComponent from "@/components/parent/relatorio/configuracoesImpresaoXLS.vue";
import { Component, Watch } from "@/decorators";
import PaginationPackModel from "@/models/auxiliar/paginationPackModel";
import ConfiguracaoImpressaoModel from "@/models/configuracaoImpressaoModel";
import ProdutoModel, { ProdutoListParameters } from "@/models/produto/produtoModel";
import UsuarioModel from "@/models/usuarioModel";
import grupoProdutoService from "@/services/produto/grupoProdutoService";
import produtoService from "@/services/produto/produtoService";
import { AppState, Getters, SessionActions } from "@/store/store";
import Delay from "@/utils/common/delay";
import FileHelper from "@/utils/common/fileHelper";

import "../crud.scss";

@Component({
    components: {
        gridComponent,
        comboComponent,
        configuracoesImpresaoXLSComponent,
    },
    computed: {
        ...mapState({
            loadingPack: (state: AppState) => state.paginationStatus.loading,
            paginationParams: (state: AppState) => state.paginationStatus.paginationParams,
            usuarioLogado: (state: AppState) => state.session.usuarioLogado,
        }),
        ...mapGetters([
            "HAS_PERMISSAO_PERFIL",
            "GET_IS_FRACIONAMENTO",
            "GET_IS_ESTEREIS",
            "VALIDAR_PERMISSAO_USUARIO",
        ] as Getters),
    },
    methods: mapMutations(["SET_PARAMS", "CLEAR_LISTSPACK", "GET_PARAMS"]),
})
export default class ProdutoListComponent extends Vue {
    // State computed props
    loadingPack: boolean;
    paginationParams: PaginationPackModel;
    SET_PARAMS: (obj: object) => void;
    GET_PARAMS: (path: string) => Promise<void>;
    HAS_PERMISSAO_PERFIL: (isRede: boolean, isFranqueador: boolean, isSuporte: boolean) => Promise<boolean>;
    GET_IS_FRACIONAMENTO: () => Promise<boolean>;
    GET_IS_ESTEREIS: () => Promise<boolean>;
    usuarioLogado: UsuarioModel;
    VALIDAR_PERMISSAO_USUARIO: (telaDescricao: string, acaoController: string) => boolean;

    private configuracoesImpresaoXLSComponent: ConfiguracoesImpresaoXLSComponent = null;

    startFilterKey = "";
    gridFilterKey = "";
    gridSortKey = "descricao";
    gridSortOrder = "asc";
    gridData: Array<ProdutoModel> = [];
    get gridColumns(): Array<GridColumn> {
        return [
            new GridColumn("id", "Código", GridColumnType.String),
            new GridColumn("descricao", "Descri\u00e7\u00e3o", GridColumnType.String),
            new GridColumn("sinonimos", "Sinônimos", GridColumnType.String, false, false, "", "", false, false),
            new GridColumn("grupo", "Grupo", GridColumnType.String),
            new GridColumn("ativo", "Ativo", GridColumnType.Boolean),
        ];
    }

    public hideExtras = false;
    public showAddNewButton = true;

    grupoProdutoOptions: Array<Object> = [];
    subGrupoOptions: Array<Object> = [
        { text: "Ativo", value: 0 },
        { text: "Flavorizante", value: 1 },
        { text: " Veículos/Excipientes", value: 2 },
        { text: "Sólido", value: 8 },
        { text: "Semissólido", value: 9 },
        { text: "Líquido", value: 10 },
    ];
    situacaoProdutoOptions: Array<Object> = [
        { text: "Produtos Ativos", value: 1 },
        { text: "Produtos Inativos", value: 0 },
        { text: "Todos os Produtos", value: -1 },
    ];
    loadedPagination = false;
    pageIndex = 1;
    pageSize = 20;
    total = 0;
    filtro: Array<Object> = [];
    isHidden = false;
    situacaoProdutoFiltro?: number = null;
    grupoProdutoFiltro?: number = null;
    subGrupo?: number = null;
    isAdmin = false;
    customParameters: ProdutoListParameters;

    private async load() {
        this.customParameters = {
            combo: this.filtro[0] != null ? this.filtro[0].toString() : "",
            sub: this.filtro[1] != null ? this.filtro[1].toString() : "",
            somenteAtivos: this.filtro[2] == null || this.filtro[2] === -1 ? null : Boolean(this.filtro[2]),
        };
        try {
            const data = await produtoService.list(
                this.gridFilterKey,
                this.gridSortKey,
                this.gridSortOrder,
                this.pageIndex,
                this.pageSize,
                this.customParameters,
            );

            this.gridData = data.list;
            this.total = data.total;
            this.pageIndex = data.pageIndex;
            this.pageSize = data.pageSize;

            //atualiza params no store
            if (data.total > 0) {
                this.SET_PARAMS({
                    routePath: this.$route.path,
                    filterKey: this.gridFilterKey,
                    sortKey: this.gridSortKey,
                    sortOrder: this.gridSortOrder,
                    pageIndex: this.pageIndex,
                    pageSize: this.pageSize,
                    filtros: this.filtro,
                });
            }

            this.isHidden = false;
        } catch {}
    }

    private getFormValues() {
        this.filtro = [];
        this.filtro.push(this.grupoProdutoFiltro);
        this.filtro.push(this.subGrupo);
        this.filtro.push(this.situacaoProdutoFiltro);
        this.pageIndex = 1;
        this.load();
    }

    private onEditItem(model: ProdutoModel) {
        this.$router.push("/produto-edicao/" + model.id);
    }

    private async onRemoveItem(model: ProdutoModel) {
        const response = await this.$showExclusaoQuestion(`${this.$t("__.ts.desejaExcl")}${model.descricao}?`);

        if (response) {
            try {
                const sucesso = await produtoService.delete(model.id, this.usuarioLogado.franquiaId);

                if (sucesso) {
                    this.load();
                    this.$showExclusao();
                }
            } catch {}
        }
    }

    @Watch("pags")
    private onPags() {
        this.load();
    }

    private onCreateItem() {
        this.$router.push("/produto-edicao");
    }

    private onChangeFilterKey(filterKey: string) {
        this.gridFilterKey = filterKey;
        this.pageIndex = 1;
        this.load();
    }

    private onChangeSort(sortKey: string, sortOrder: string) {
        this.gridSortKey = sortKey;
        this.gridSortOrder = sortOrder;
        this.load();
    }

    private onChangePage(pageIndex: number) {
        this.pageIndex = pageIndex;
        this.load();
    }
    private async loadPagination() {
        await this.GET_PARAMS(this.$route.path);
        while (this.loadingPack) await Delay(50);

        if (this.paginationParams != null) {
            this.gridFilterKey = this.paginationParams.filterKey;
            this.startFilterKey = this.gridFilterKey;

            this.gridSortKey = this.paginationParams.sortKey;
            this.gridSortOrder = this.paginationParams.sortOrder;
            this.pageIndex = this.paginationParams.pageIndex;
            this.pageSize = this.paginationParams.pageSize;
            if (this.paginationParams.filtros != null) {
                this.filtro = this.paginationParams.filtros;
                if (this.filtro.length >= 0) {
                    this.grupoProdutoFiltro = <number>this.filtro[0];
                    if (this.filtro.length >= 1) this.subGrupo = <number>this.filtro[1];
                }
            }
        }
        this.loadedPagination = true;
    }

    private async atualizaMarkup() {
        try {
            const response = await produtoService.atualizarValorVenda().withLoading().resolveWithResponse();
            if (response.ok) {
                this.$showSuccess(this.$t("__.ts.atualizacao"), this.$t("__.ts.vlrsVendaAtualizSucess"));
            }
        } catch {}
    }

    private onChangePageSize(newPageSize) {
        this.pageIndex = 1;
        this.pageSize = newPageSize;
        this.load();
    }

    public downloadPDF() {
        produtoService.exportPDF(this.gridFilterKey, this.gridSortKey, this.gridSortOrder, this.customParameters);
    }

    public async downloadXLS() {
        this.configuracoesImpresaoXLSComponent = this.$refs
            .configuracoesImpresaoXLSComponent as ConfiguracoesImpresaoXLSComponent;
        this.configuracoesImpresaoXLSComponent.open();
    }

    private async onConfirmXLS(config: ConfiguracaoImpressaoModel) {
        try {
            const response = await produtoService
                .exportXLS(
                    this.gridFilterKey,
                    this.gridSortKey,
                    this.gridSortOrder,
                    this.customParameters,
                    config.tipoExportacaoXLS,
                )
                .withLoading()
                .resolveWithResponse();
            const data = await response.blob();

            const blob = new Blob([data], { type: response.headers.get("Content-Type") });
            const fileName = response.headers.get("Content-Disposition").split("filename=")[1].split(";")[0];
            FileHelper.download(blob, fileName);
        } catch {}
    }

    private beforeMount() {
        this.loadPagination();
    }

    private async mounted() {
        this.isAdmin = await this.HAS_PERMISSAO_PERFIL(true, false, false);
        await this.$store.dispatch(SessionActions.LOAD_USUARIO_LOGADO);

        const response = await Promise.all([
            grupoProdutoService.comboCached(this.usuarioLogado.franquiaId),
        ]).withLoading();

        this.grupoProdutoOptions = response[0];
        this.load();

        const bloquearCadastroDeProduto =
            ((await this.GET_IS_FRACIONAMENTO()) || (await this.GET_IS_ESTEREIS())) &&
            !this.VALIDAR_PERMISSAO_USUARIO("produtos", "InsertProdutoIndustria");

        this.showAddNewButton = !(bloquearCadastroDeProduto || this.hideExtras);
    }
}
